module.exports = __webpack_public_path__ + "static/media/unibest-solution-img5.34447194.png";